import React from 'react';
import Box from '@mui/material/Box';
import AttachmentChip from './AttachmentChip';
import type { Attachment } from './types';

interface Props {
  attachments: Attachment[];
  onRemove: (filename: string) => void;
  disabled?: boolean;
}

const AttachmentChipRow: React.FC<Props> = ({ attachments, onRemove, disabled }) => {
  if (!attachments || attachments.length === 0) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        px: 1.5,
        py: 0.75,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      {attachments.map((a) => (
        <AttachmentChip
          key={a.filename}
          attachment={a}
          disabled={disabled}
          onRemove={() => onRemove(a.filename)}
        />
      ))}
    </Box>
  );
};

export default AttachmentChipRow;
